"use strict";
/**
 * Using this shared file version since there would be a circular dependency
 * if placed within the "Reporting" type file. This is due to "Reporting"
 * and "DbTables" both utilizes "CreditAgreement" types so can't import
 * "Reporting" to "DbTables".
 * Can look to reorganize some of these type files and remove the reliance
 * of these shared files
 */
// ************************************************
//              REPORTING ENTITY RECORD
// ************************************************
Object.defineProperty(exports, "__esModule", { value: true });
const ReportingAccessorDomains = [
    'borrowingBaseReport',
    'fundingRequest',
    'orgProvidedValue',
    'portfolioCovenant',
    'financialCovenant',
];
const ReportingEntityDbNamespaces = [
    'borrowing_base_reports',
    'funding_requests',
    'org_provided_values',
    'portfolio_covenants',
    'financial_covenants',
];
//# sourceMappingURL=SharedReporting.js.map